"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toString = void 0;
function toString(input) {
    if (typeof input === 'object' && input !== null) {
        if (typeof input.toString === 'function') {
            input = input.toString();
        }
        else {
            input = '[object Object]';
        }
    }
    else if (input === null || typeof input === 'undefined' || (isNaN(input) && !input.length)) {
        input = '';
    }
    return String(input);
}
exports.toString = toString;
